import {createBrowserHistory } from 'history';
export const history = createBrowserHistory({forceRefresh: true, basename:process.env.REACT_APP_BASENAME});